import { useEffect, useMemo, useState } from 'react';

export const useDebounce = <K>(value: K, delay = 300, doUpdate?: (value: K) => void): K => {
  const [debouncedValue, setDebouncedValue] = useState(value);

  useEffect(() => {
    const handler = setTimeout(() => {
      if (JSON.stringify(debouncedValue) === JSON.stringify(value)) return;
      setDebouncedValue(value);
      doUpdate?.(value);
    }, delay);

    return () => {
      clearTimeout(handler);
    };
  }, [value, delay, doUpdate, debouncedValue]);

  return useMemo(() => debouncedValue, [debouncedValue]);
};
